import { render } from "./BrowseView.vue?vue&type=template&id=338a0dfb&scoped=true&ts=true"
import script from "./BrowseView.vue?vue&type=script&lang=ts"
export * from "./BrowseView.vue?vue&type=script&lang=ts"

import "./BrowseView.vue?vue&type=style&index=0&id=338a0dfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338a0dfb"]])

export default __exports__